import React from "react";
import Spinner from "react-bootstrap/Spinner";

const SpinnerButton = () => {
  return (
    <button
      className="btn btn-dark btn mb-2  btn-block"
      type="button"
    >
      <Spinner animation="border" variant="light" />
    </button>
  );
};

export default SpinnerButton;
